import createReducer from './../lib/createReducer';
import * as types from './../actions/types';

export const app = createReducer({
  leftSidenav: true,
}, {
  [types.TOGGLE_LEFT_SIDENAV](state) {
    const newState = Object.assign({}, {
      leftSidenav: !state.leftSidenav,
    });

    return newState;
  },
});

export { app as default };
